<ng-template #mediaTpl>
  @if (isOpen() && mediaUrl) {
    @if (contentType === 'application/pdf') {
      <!-- PDF File: iframe, never object - Safari shows no PDF in an object, and the CSP forbids object anyway -->
      @if (isPdfViewerDisabled()) {
        <!-- Browser shows no PDFs inline - an empty frame would be inexplicable -->
        <div class="object-wrapper d-flex justify-content-center align-items-center">
          <p class="m-4">{{ 'media.view.pdfDisabled'|translate }}</p>
        </div>
      } @else {
        <div class="iframe-wrapper">
          <iframe [src]="mediaUrl"></iframe>
        </div>
      }
    } @else if (contentType === 'image/png' || contentType === 'image/jpg' || contentType === 'image/jpeg') {
      <!-- PNG/JPEG Image: img, not object - the CSP forbids object entirely (object-src 'none') -->
      <div class="object-wrapper d-flex justify-content-center align-items-center">
        @if (imageFailed) {
          <p class="m-4">{{ 'media.view.error'|translate }}</p>
        } @else {
          <img [src]="mediaUrl" alt="" (error)="imageFailed = true">
        }
      </div>
    } @else if (contentType === 'text/xml' && formattedXml) {
      <!-- XML File -->
      <div class="object-wrapper">
        <pre class="m-4 xml-content">{{ formattedXml }}</pre>
      </div>
    } @else if (contentType === 'text/csv' && formattedCsv) {
      <!-- CSV File -->
      <div class="object-wrapper">
        <pre class="m-4 csv-content">{{ formattedCsv }}</pre>
      </div>
    }

    <acc-card>
      <acc-card-body>
        <acc-action-bar>
          @if (isDownloadAllowed()) {
            <acc-button status="primary" (accClick)="download()">
              <acc-icon name="download"/>
              {{ 'media.action.download'|translate }}
            </acc-button>
          }
          <!-- Send Letter START -->
          @if (showLetterSendViewer && perms.correspondence.write) {
            <acc-button status="primary" (accClick)="openLetterPriceCalc()">
              <acc-icon name="letter"/>
              {{ 'letter.action.title'|translate }}
              <acc-icon name="help" [ngbTooltip]="'letter.action.info'|translate"/>
            </acc-button>
          }
          <!-- Send Letter END -->
          <!-- Send Email START -->
          @if (showEmailSendViewer && perms.correspondence.write) {
            <acc-button status="primary" (accClick)="openEmailSendViewer()">
              <acc-icon name="email"/>
              {{ 'email.send.title'|translate }}
            </acc-button>
          }
          <!-- Send Email END -->
          <!-- Tag Editor START
          @if (isTagsType() && hasPermission(PermissionGrant.R)) {
            <acc-form [wrapper]="getTagsWrapper()" [showFooter]="false">
              <acc-form-input name="tags" [wrapper]="getTagsWrapper()" [config]="inputConfig"/>
            </acc-form>
          } -->
          <!-- Tag Editor END -->
          <!-- Delete START
          @if (isDeletableType() && hasPermission(PermissionGrant.RWD)) {
            <acc-button status="outline-danger" [disabled]="!isDeletable()"
                        (accClick)="deleteConfirm.open()">
              <acc-icon name="delete"/>
              {{ 'delete'|translate }}
            </acc-button>
            <acc-modal #deleteConfirm type="delete"
                       [title]="'media.delete.confirm.title'|translate"
                       [body]="'media.delete.confirm.body'|translate"
                       (accConfirmed)="delete()">
              <p class="fw-bold">TODO Media</p>
            </acc-modal>
          } -->
          <!-- Delete END -->
          <acc-button class="ms-auto" status="outline-gray" (accClick)="close()">
            {{ 'modal.close'|translate }}
          </acc-button>
        </acc-action-bar>
      </acc-card-body>
    </acc-card>
  } @else {
    <acc-spinner/>
  }
</ng-template>

<acc-letter-send-viewer #letterSendViewer/>
<acc-email-send-viewer #emailSendViewer/>
